module.exports = __webpack_public_path__ + "img/pc_operate_contact.cb1cdf7b.jpg";